/**
 * Material identifier to fill color for visualization.
 */

export const DEFAULT_TEXT_COLOR = '#b8860b';

export const MATERIAL_COLORS: Record<string, string> = {
  aluminium: '#a3a7a9',
  bronze: '#CD7F32',
  'MS-Bzton': '#8b7355',
};

export function getMaterialColor(materialIdentifier: string | undefined): string {
  if (!materialIdentifier) return DEFAULT_TEXT_COLOR;
  return MATERIAL_COLORS[materialIdentifier.toLowerCase()] ?? MATERIAL_COLORS[materialIdentifier] ?? DEFAULT_TEXT_COLOR;
}
